export class VetologyBase
{
    constructor(className)
    {
        const o = this;
        o._className = null;
        if (className !== undefined) {
            o._className = className;
        }

        if (o._className) {
            console.log(o._className + " created");
        }
        o.#create();
    }

    #create()
    {

    }

    #init()
    {

    }


}
